import styled from "styled-components"

import { maxWidth } from "utils"

import Icon from "icons"
import CloudinaryImage from "components/cloudinary-image"
import CroppedImage from "components/cropped-image"
import GeneralCard from "../base"
import { Headline } from "../base/styles"

export const PodcastCategory = styled.div`
  font-size: 1.2rem;
  font-weight: 500;
  letter-spacing: 0.2rem;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.primaryOrange};
`

export const PodcastLogo = styled.div`
  font-family: Monoline, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 2rem;

  ::before {
    content: "Mbg";
  }

  ::after {
    content: "podcast";
    color: ${({ theme }) => theme.colors.podcasts};
  }
`

export const BottomRight = styled.div`
  padding: 0.8rem 0rem 0rem 0.8rem;
  border-radius: 100% 0 0 0;
  background-color: #fff;
`

export const DesktopWrapper = styled.div`
  ${maxWidth.mobile`
    display: none;
  `}
`

export const MobileWrapper = styled.div`
  display: none;

  ${maxWidth.mobile`
    display: block;
  `}
`

export const DesktopCard = styled(GeneralCard)`
  margin: 0;

  .card-header {
    padding: 0;
  }
`

export const MobileCard = styled(GeneralCard)`
  border: 0.1rem solid rgba(34, 34, 34, 0.2);
  border-radius: 0;
`

export const ImageRegular = styled(CloudinaryImage)`
  padding-bottom: calc(555 / 661 * 100%);

  ${maxWidth.mobile`
    width: 100%;
    height: 14.1rem;
    padding-bottom: unset;
  `}
`

export const ImageCropped = styled(CroppedImage)`
  padding-bottom: calc(555 / 661 * 100%);

  ${maxWidth.mobile`
    width: 100%;
    height: 14.1rem;
    padding-bottom: unset;
  `}
`

export const Video = styled.video`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  ${maxWidth.mobile`
    display: none;
  `}
`

export const Content = styled.div`
  position: absolute;
  bottom: 2rem;
  left: 2rem;
  right: 14%;
  padding: 2rem;
  background-color: #fff;

  ${maxWidth.mobile`
    position: relative;
    bottom: unset;
    left: unset;
    right: unset;
  `}
`

export const StyledHeadline = styled(Headline)`
  ${maxWidth.mobile`
    min-height: 10.2rem;
  `}
`

export const Category = styled.div`
  margin-top: 2rem;
  font-size: 1.4rem;
  line-height: 2.184rem;
  color: rgba(34, 34, 34, 0.8);
`

export const Body = styled.div`
  font-size: 1.6rem;
  line-height: 2.496rem;
`

export const Play = styled.div`
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  line-height: 1.872rem;
`

export const PlayIcon = styled(Icon)``
